import React, { useEffect, useState, useRef } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Spinner from '../layout/Spinner';
import { Redirect } from 'react-router-dom';
import SidebarAdmin from '../layout/SidebarAdmin';
import EventoElement from '../eventi/EventoElement';
import { getEventiAgenda } from '../../actions/agenda';
import { extractRoomKey, isDateTimeTodayAndPassed } from '../../utils/utilityfunction';

const GestionePortale = ({ auth: { user, loading }, alert, getEventiAgenda, agenda: { eventi }  }) => {

  const [eventiData, setEventiData] = useState([]);
  const [, setRenderTick] = useState(0);
  const mountedRef = useRef(true);

  useEffect(() => {
    getEventiAgenda();
    const interval = setInterval(() => {
      if (mountedRef.current) setRenderTick(n => n + 1);
    }, 30000);
    return () => {
      mountedRef.current = false;
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
		setEventiData(eventi)
	}, [eventi]);

  if (user && user.ruolo !== 'admin') {
    return <Redirect to="/login" />;
  }

  return (loading ? <Spinner /> :
    <section className="fd-section wide">
      <div className="w-layout-blockcontainer fd-container null w-container">
        <div className="fd-wrap backend">
          <SidebarAdmin />
          <div>
            <div>
              <div className="w-layout-blockcontainer fd-container backend w-container">
                <div className="fd-wrap">
                  <div className="w100">
                    <div>
                      <h1 className="heading-3">L'agenda</h1>
                    </div>
                    <div className="call-elenco">
                                  {eventiData.length == 0 ?
                      <div class="nessun_evento">Non c’è ancora nessun evento in programma</div>

                    :
                                  eventiData.map((el) => (
                                    <EventoElement
                                    titoloEvento={el.titolo}
                                    descrizioneEvento={el.descrizione}
                                    dataEvento={el.data}
                                    orarioEvento={el.orario}
                                    linkEvento={el.link}
                                    roomName={el.roomName}
                                    roomKey={extractRoomKey(el.hostRoomUrl)}
                                    idEvento= {el._id}
                                    meetingId ={el.meetingId}
                                    archivio={false}
                                    isActive={isDateTimeTodayAndPassed(el.data, el.orario, user)}
                                  />
                                ))}
                                </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
};

GestionePortale.propTypes = {
  auth: PropTypes.object.isRequired,
  alert: PropTypes.object.isRequired,
  agenda: PropTypes.func.isRequired,
  getEventiAgenda: PropTypes.func.isRequired

}

const mapStateToProps = state => ({
  auth: state.auth,
  alert: state.alert,
  agenda: state.agenda
});

export default connect(mapStateToProps, { getEventiAgenda })(GestionePortale);